import React from 'react';
import loginBackground from '../../../../assets/images/login-background.png';
import vamosLogo from '../../../../assets/images/vamos-horizontal-logo.png';
import ResendEmailForm from '../../componentsV2/PasswordReset/ResendEmailForm';
import { ToastProvider } from '../../providers/ToastProvider';
import PageFooter from '../../componentsV2/PageFooter/PageFooter';

const ResendEmailPage = () => {
  return (
    <ToastProvider>
      <div
        className="min-h-screen w-screen bg-no-repeat bg-top-0 overflow-y-auto flex flex-col justify-between"
        style={{ backgroundImage: `url(${loginBackground})` }}
      >
        <div className="flex flex-col items-end">
          <div className="flex flex-col items-center justify-center w-full md:w-3/4 xl:w-1/3 mr-0 md:mr-47 mx-auto mb-8">
            <img
              src={vamosLogo}
              alt="Vamos horizontal logo"
              className="w-100 h-36.5 flex-shrink-0"
            />
            <ResendEmailForm />
          </div>
        </div>
        <PageFooter />
      </div>
    </ToastProvider>
  );
};

export default ResendEmailPage;
